module.exports = __webpack_public_path__ + "img/cover-promotion-bg.5e8728cd.jpg";